import { CalendarConfigResponse } from "@/models/api/CalendarConfigResponse";
import { CalendarConfig } from "@/models/www/CalendarConfig";
import baseApi from "./api.service";

const calendarService = {
	async getCalendarSettings(route: string, startDate?: string,): Promise<CalendarConfig> {
		const reqUrl = startDate ? `settings/calendar/${route}/${startDate}` : `settings/calendar/${route}/`
		return new Promise((resolve, reject) => {
			baseApi.get<CalendarConfigResponse>(reqUrl)
				.then(resp => resolve(new CalendarConfig(resp)))
				.catch(err => reject(err))
		})
	}
}

export default calendarService;